import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../../../app/shared/_services/api.service';
import { environment } from '../../../environments/environment';
import { getOrigin } from '../../shared/util';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styles: []
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private router: Router,
    private localize: LocalizeRouterService
  ) { }

  jsonIn: any = {};
  errore;

  loginReturn = encodeURIComponent(getOrigin() + this.localize.translateRoute('/area-riservata').toString());

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.jsonIn.token = params.token;
    });
  }


  conferma() {
    console.log(this.jsonIn);
    this.api.modificaPasswordProvvisoria(this.jsonIn).subscribe((res: any) => {
      if (res.esito === 'OK') {
        this.router.navigateByUrl(this.localize.translateRoute('/login').toString() + `?returnUrl=${this.loginReturn}`);
      } else {
        this.errore = true;
      }
    });
  }


}
